<template>
  <div class="edit_main">
    <h3>修改登录密码</h3>
    <Form
      class="updateForm"
      ref="updatePassWordModel"
      :model="updatePassWordModel"
      :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="旧密码" prop="oldPassWord">
        <Input
          class="w-250"
          placeholder="请输入旧密码"
          type="password"
          v-model="updatePassWordModel.oldPassWord"
        ></Input>
      </FormItem>
      <FormItem label="新密码" prop="newPassWord">
        <Input
          password="true"
          class="w-250"
          placeholder="密码至少6位数"
          type="password"
          v-model="updatePassWordModel.newPassWord"
        ></Input>
      </FormItem>
      <FormItem label="确认新密码" prop="confirmPassWord">
        <Input
          password="true"
          class="w-250"
          placeholder="请输入确认密码"
          type="password"
          v-model="updatePassWordModel.confirmPassWord"
        ></Input>
      </FormItem>
    </Form>
    <div class="text-center">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="updatePassWordSubmit('updatePassWordModel')">确 定</Button>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    const validatePass = (rule, value, callback) => {
      const regex = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,16}')
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        // 密码中必须包含大小字母、数字、特称字符，至少8个字符，最多16个字符。
        if (!regex.test(value)) {
          callback(new Error('密码必须8至16位包含大小写字母、数字、特称字符'))
        }
        callback()
      }
    }
    return {
      updatePassWordModel: {
        userId: "",
        oldPassWord: "",
        newPassWord: "",
        confirmPassWord: "",
      },
      ruleValidate: {
        oldPassWord: [
          {
            required: true,
            message: "旧密码不能为空",
          },
        ],
        newPassWord: [
          {
            required: true,
            message: "新密码不能为空",
            // validator:validatePass
          },
        ],
        confirmPassWord: [
          {
            required: true,
            message: "确认新密码不能为空",
          },
        ],
      },
    };
  },
  created() {
    this.updatePassWordModel.userId = this.$store.state.id;
  },
  methods: {
    updatePassWordSubmit(from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api
            .post("user/updatePassword", this.updatePassWordModel)
            .then((rsp) => {
              if (rsp != false) {
                this.$Message.success("修改成功");
                // this.$router.push({ path: "/login" });
                // this.$router.push('/login')
                this.$store.dispatch("loginOut", null).then((rsp) => {
                  this.$router.push({ path: "/login" });
                });
              }
            });
        }
      });
    },

    returnBack() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>
<style scoped>
.updateForm {
  /* width: 500px; */
  margin: auto;
  margin-top: 8%;
}
</style>
